import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { VulcanIconComponent } from '@eagle-i/vulcan-component-library';
import { FileDownload } from '../../../../../../../shared/classes/fileDownload';

interface iDefinition {
    title: string;
    description: string;
}

@Component({
    selector: 'tgrid-outage-duration-definition-widget',
    templateUrl: './outage-duration-definition-widget.component.html',
    styleUrls: ['./outage-duration-definition-widget.component.scss'],
    imports: [MatCardModule, MatButtonModule, VulcanIconComponent],
})
export class OutageDurationDefinitionWidgetComponent {
    protected definitions: iDefinition[] = [
        {
            title: 'Recovery Duration',
            description: 'Measures the time between when the maximum number of customer are impacted (Impact Level) and the end of the outage event',
        },
        {
            title: 'Area Under the Curve (AUC)',
            description: 'Demonstrates units of “customer-minutes” – combining Impact Level & Event Duration into one metric.',
        },
    ];
    protected export(): void {
        const fileName = 'outage-definitions';
        const rowList = ['Term,Definition', ...this.definitions.map(d => `${d.title},${d.description}`)];
        FileDownload.downloadCSV(fileName, rowList.join('\n'));
    }
}